import {createSelector} from 'reselect'
import keyBy from 'lodash/keyBy.js'
import sortBy from 'lodash/sortBy.js'

import {setForm, updateForm, formsSelector, getState} from '../store.js'
import {fetchAllApiverson} from '../common/fetchAll.js'
import {hasUseReturnOrdersFeatureSelector} from './company.js'

export const RETURN_ORDER_CODES = 'return_order_codes'

export function returnOrderCodesSelector(state) {
  return (
    formsSelector(state)[RETURN_ORDER_CODES] || returnOrderCodesSelector.default
  )
}
returnOrderCodesSelector.default = {}

export function returnOrderCodeSelector(state, {returnOrderCodeID}) {
  return returnOrderCodesSelector(state)[returnOrderCodeID]
}

export const returnOrderCodesSortedByCodeSelector = createSelector(
  returnOrderCodesSelector,
  (returnOrderCodes) => sortBy(returnOrderCodes, 'code'),
)

export function setReturnOrderCodes(returnOrderCodes) {
  setForm(RETURN_ORDER_CODES, keyBy(returnOrderCodes, 'id'))
}

export function setReturnOrderCode(returnOrderCode) {
  updateForm(RETURN_ORDER_CODES, {[returnOrderCode.id]: returnOrderCode})
}

export async function getReturnOrderCodes() {
  if (!hasUseReturnOrdersFeatureSelector(getState())) {
    return
  }

  const returnOrderCodes = await fetchAllApiverson(
    '/return_order/code/',
    'code',
  )

  setReturnOrderCodes(returnOrderCodes)
}
